module.exports = __webpack_public_path__ + "img/symbol_1.ab2cf935.png";